import {identity} from "lodash";
import {SHARE_LINK} from "modules/constants";
import {IGeneralShareEntity, IServerShareEntity} from "modules/types";
import {ShareTarget} from "modules/enums";

export const getEncodedJson = <T>(object: T) => btoa(JSON.stringify(object));

export const getLinkForShare = <T>(object: T) => {
	return SHARE_LINK;
	// const encodedJson = getEncodedJson(object);
	// return `${FB_SHARE_URL}prediction/${encodedJson}`;
};

const prepareShareObject = (data: IGeneralShareEntity): IServerShareEntity => {
	return {
		t: getTimestamp(),
		contestId: data.contestId,
		userId: data.userId,
	};
};

export function getLinkFromSharePublicMethod(data: IGeneralShareEntity): string {
	return SHARE_LINK;
	// const object = prepareShareObject(data);
	// return getLinkForShare(object);
}

const last_four_number = -4;
const getTimestamp = () => Date.now().toString().substr(last_four_number);

// const shareFacebook = (data: IGeneralShareEntity) => {
// 	const FB_API = get(window, "FB");
//
// 	if (!FB_API) {
// 		throw Error("No FB api found");
// 	}
//
// 	// const object = prepareShareObject(data);
//
// 	FB_API.ui(
// 		{
// 			method: "share",
// 			display: "popup",
// 			href: SHARE_LINK,
// 		},
// 		(response: unknown) => {
// 			console.log(response);
// 		}
// 	);
// };

const shareFacebook = (data: IGeneralShareEntity) => {
	const link = getLinkForShare(data);

	if (!window.FB) {
		const winWidth = 626;
		const winHeight = 436;
		const winTop = window.screen.height / 2 - winHeight / 2;
		const winLeft = window.screen.width / 2 - winWidth / 2;

		window.open(
			`https://www.facebook.com/sharer/sharer.php?display=popup&u=${link}`,
			"_blank",
			`top=${winTop},left=${winLeft},width=${winWidth}, height=${winHeight},toolbar=0,status=0,scrollbars=no,resizable=1`
		);
		return;
	}

	window.FB.ui(
		{
			method: "share",
			display: "popup",
			href: link,
		},
		identity
	);
};

const shareTwitter = (data: IGeneralShareEntity) => {
	// const object = prepareShareObject(data);
	// const href = getLinkForShare(object);
	window.open(
		// `https://twitter.com/share?url=${encodeURIComponent(href)}&text=${encodeURIComponent(
		`https://twitter.com/share?url=${SHARE_LINK}&text=${encodeURIComponent(data.message)}`,
		"twitter-share-dialog",
		"width=626,height=436"
	);
};

const shareNative = async (data: IGeneralShareEntity) => {
	try {
		const object = prepareShareObject(data);
		const href = getLinkForShare(object);

		const shareData = {
			url: href,
			text: data.message,
		};

		await navigator.share(shareData);
	} catch (err) {
		const error = err as Error;
		console.warn(error.message);
	}
};

const shareMap = {
	[ShareTarget.Twitter]: shareTwitter,
	[ShareTarget.Facebook]: shareFacebook,
	[ShareTarget.Native]: shareNative,
} as const;

export const share = async (data: IGeneralShareEntity) => {
	const shareFunction = shareMap[data.target];

	if (shareFunction && typeof shareFunction === "function") {
		await shareFunction(data);
	}
};
